import { create } from 'zustand';

/**
 * Globale store voor de opportunity-detail drawer (Cinco-platform
 * doorverwijzingen). Mirror van order-detail-drawer-store: elke page kan
 * `useOpportunityDetailDrawerStore.open(id)` aanroepen. Direct-link naar de
 * volledige aanvraag blijft werken via de /opportunities/:id route.
 */
interface OpportunityDetailDrawerState {
  openOpportunityId: string | null;
  open: (id: string) => void;
  close: () => void;
}

export const useOpportunityDetailDrawerStore = create<OpportunityDetailDrawerState>((set) => ({
  openOpportunityId: null,
  open: (id) => set({ openOpportunityId: id }),
  close: () => set({ openOpportunityId: null }),
}));
